import { SquareMatrixSolver } from "./SquareMatrixSolver";
export function getPerspectiveWarp(src, dst) {
    const imf = dst;
    const txf = src;
    const lhs = [
        [imf[0][0], imf[0][1], 1, 0, 0, 0, -txf[0][0] * imf[0][0], -txf[0][0] * imf[0][1]],
        [0, 0, 0, imf[0][0], imf[0][1], 1, -txf[0][1] * imf[0][0], -txf[0][1] * imf[0][1]],
        [imf[1][0], imf[1][1], 1, 0, 0, 0, -txf[1][0] * imf[1][0], -txf[1][0] * imf[1][1]],
        [0, 0, 0, imf[1][0], imf[1][1], 1, -txf[1][1] * imf[1][0], -txf[1][1] * imf[1][1]],
        [imf[2][0], imf[2][1], 1, 0, 0, 0, -txf[2][0] * imf[2][0], -txf[2][0] * imf[2][1]],
        [0, 0, 0, imf[2][0], imf[2][1], 1, -txf[2][1] * imf[2][0], -txf[2][1] * imf[2][1]],
        [imf[3][0], imf[3][1], 1, 0, 0, 0, -txf[3][0] * imf[3][0], -txf[3][0] * imf[3][1]],
        [0, 0, 0, imf[3][0], imf[3][1], 1, -txf[3][1] * imf[3][0], -txf[3][1] * imf[3][1]],
    ];
    const rhs = [txf[0][0], txf[0][1], txf[1][0], txf[1][1], txf[2][0], txf[2][1], txf[3][0], txf[3][1]];
    const solver = new SquareMatrixSolver(lhs);
    return solver.solve(rhs);
}
export function transpose3x31D(matrix) {
    const transpose = new Array(matrix.length).fill(0);
    for (let row = 0; row < 3; row++) {
        for (let col = 0; col < 3; col++) {
            transpose[col * 3 + row] = matrix[row * 3 + col];
        }
    }
    return transpose;
}
//# sourceMappingURL=matrix.js.map